import React, { useState, useMemo, useEffect } from 'react'
import { Typography, Box } from '@mui/material'
import PropTypes from 'prop-types'
import { refine } from '@components/plp/helpers/refine'
import CollectionTileV2 from '@components/collection-tile-v2/CollectionTileV2'

const SearchQueryCollection = ({ results }) => {
  const [refinedSearchResults, setRefinedSearchResults] = useState(null)

  // Parse initial search response
  const searchResponse = useMemo(() => (results?.fields ? JSON.parse(results?.fields.response) : null), [results])
  const hits = searchResponse?.content?.hits || []

  // While results are fetched on the server, we also fetch on the client and backend's request
  // in case there are differences between cached results and real-time results.
  useEffect(() => {
    const initialRefine = async () => {
      if (searchResponse) {
        try {
          const initialResults = await refine({
            oldState: {
              ...searchResponse.content._state,
              attributesToRetrieve: ['*', '-reviews'],
              hitsPerPage: 50,
            },
            filters: searchResponse.filters,
            page: 1,
            index: `collection-${process.env.GATSBY_ALGOLIA_REGION_INDEX}`,
            plpBanners: 0,
          })
          setRefinedSearchResults(initialResults)
        } catch (error) {
          console.error('Error during initial refine:', error)
        }
      }
    }

    initialRefine()
  }, [searchResponse])

  // If no results, show message
  if (!searchResponse) {
    return (
      <div className="search-query">
        <Typography variant="subtitle1">No data found...</Typography>
      </div>
    )
  }

  // Use refined results if available, otherwise use initial hits
  const displayHits = refinedSearchResults?.content?.hits || hits
  const featuredSlots = results?.Query?.featuredSlots
  const slotOrder = results?.Query?.slotOrder

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: {
          xs: '32px',
          md: '40px',
        },
      }}
    >
      {displayHits.map((hit, index) => (
        <CollectionTileV2 key={hit.title} collection={hit} featuredSlots={featuredSlots} slotOrder={slotOrder} />
      ))}
    </Box>
  )
}

SearchQueryCollection.propTypes = {
  results: PropTypes.shape({
    fields: PropTypes.shape({
      response: PropTypes.string,
    }),
    PlpBanners: PropTypes.array,
    Query: PropTypes.shape({
      featuredSlots: PropTypes.array,
      slotOrder: PropTypes.array,
    }),
  }),
}

export default SearchQueryCollection
